import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Link, useNavigate} from 'react-router-dom';
import Select from 'react-select';
import {useForm, Controller} from "react-hook-form";
import {useDispatch} from 'react-redux';
import {addUrl} from '../histori/HistoriSlice';
import PokemonCard from "../components/PokemonCard";
import Navbar from "../components/Navbar";
import { ToastContainer, toast } from 'react-toastify';
function Poke() {
    const navigate = useNavigate();
    const [pokemane, setPokemane] = useState(null);
    const [names, setNames] = useState([]);
    const [pokeInfo,setPokeInfo] = useState([])
    const [pokemaneTypes , setPokemaneTypes] = useState();
    const [curTeam,setCurTeam] = useState(localStorage.getItem(1));
    if (!localStorage.getItem("1")) {
        localStorage.setItem("1", "team1");
    }

    useEffect(() => {
        axios.get(`https://pokeapi.co/api/v2/pokemon?limit=1302&offset=0`)
            .then(res => setPokemane(res.data))
            .catch(err => console.error(err));

        axios.get(`https://pokeapi.co/api/v2/type`)
            .then(res => setPokemaneTypes(res.data.results))
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        if (!pokemane) return;

        if (pokemane?.results?.length > 0) {
            const options = pokemane.results.map(i => ({
                value: i.name,
                label: i.name
            }));

            setNames(options);
        }

        fetchData();
    }, [pokemane]);

    const fetchData = async () => {
        try {
            let a = [];
            for (const item of pokemane.results) {
                const res = await axios.get(`https://pokeapi.co/api/v2/pokemon/${item.name}`);

                a.push(res.data);
            }
            setPokeInfo(a);
        } catch (err) {
            console.error(err);
        }
    };

    const {handleSubmit, control} = useForm();
    //localStorage.setItem(0,20)

    const dispatch = useDispatch();

    const onSubmit = (data) => {
        const name = data.pokemonnam?.value;
        if (name) {
            const path = `/pokemons/${name}`;
            dispatch(addUrl(path));
            localStorage.setItem(0,"/pokemons")
            navigate(path);

        }
    };

    const toggleTeam = () => {
        let a = localStorage.getItem(1);
        if(a === "team1")
        {
            localStorage.setItem(1,"team2")
            setCurTeam(localStorage.getItem(1))
            toast.info('Changed to team 2', {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,

                progress: undefined,
                theme: "dark",

            });
        }
        else
        {
            localStorage.setItem(1,"team1")
            setCurTeam(localStorage.getItem(1))
            toast.info('Changed to team 1', {
                position: "bottom-right",
                autoClose: 3000,
                limit:2,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",

            });
        }
    };
    const [filValue,setFilValue] =useState(``)


    if (pokeInfo.length === 0) return <div className="motion-reduce: flex items-center justify-center min-h-screen">
        <button
            type="button"
            className="flex flex-col items-center px-6 py-4 bg-indigo-400 text-white text-lg font-semibold rounded-lg shadow-lg disabled:opacity-60 disabled:cursor-not-allowed">
            <svg
                className="animate-spin  h-12 w-12 text-white mb-3"
                fill={"none"}>
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    stroke="currentColor"
                    strokeWidth="3"
                ></circle>
            </svg>
            Processing…
        </button>
    </div>;

    if (!names.length) return <p className="text-center mt-10 text-gray-500">Načítání...</p>;
    console.log(pokemaneTypes)
    return (
        <div>
            <Navbar curTeam={curTeam} toggleTeam={toggleTeam} currpage={"mainpage"} />

            <div className="max-w-xl mx-auto mt-10 p-4 bg-white rounded shadow relative">
                <h1 className="text-2xl font-semibold mb-4 text-center">Najdi informace o svém Pokémonovi</h1>
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                    <Controller
                        name="pokemonnam"
                        control={control}
                        rules={{required: true}}
                        render={({field}) => (
                            <Select
                                autoFocus
                                {...field}
                                options={names}
                                placeholder="Choose Pokemon"
                            />
                        )}
                    />
                    <button
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition">
                        Zobrazit Pokémona
                    </button>
                </form>
            </div>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                }}
                className="flex items-center space-x-4 mt-6 justify-center"
            >
                <select
                    value={filValue}
                    onChange={(e) => setFilValue(e.target.value)}
                    className="border border-4 border-blue-500 px-4 py-2 rounded bg-white"
                >
                    <option value="">Vyber typ Pokémona</option>
                    {pokemaneTypes?.map((type) => (
                        <option key={type.name} value={type.name}>
                            {type.name}
                        </option>
                    ))}
                </select>
            </form>
            <div className={"pt-8 xs:flex-row xs:flex p-px justify-between flex-wrap mx-auto " }>
                {pokeInfo
                    .filter(pokemon =>
                        filValue === "" || pokemon.types.some(t => t.type.name === filValue)
                    )
                    .map((item, i) => (

                        <PokemonCard key={i} name={item.name} src={item.sprites.front_default} color={item.types} />
                    ))}
            </div>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </div>
    );
}

export default Poke;
